import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

// The single source of truth for "is this a phone".
//
// Every previous answer in this app was a one-off: a module-load snapshot of
// window.innerHeight in Wrapper, an inline window.innerWidth read in Products
// with nothing subscribed to it, one lone resize listener in CreateProduct, and
// two pages whose mobile branch was commented out entirely. theme.breakpoints
// and useMediaQuery were used exactly zero times.
//
// Subscribing to the media query rather than reading a number is the whole
// point: a rotation, a collapsing browser URL bar, or a desktop window drag all
// have to reach the component that cares.
export default function useIsMobile() {
    const theme = useTheme();
    // down('sm') is `max-width: 599.95px`, so 600 itself is desktop -- the same
    // boundary the old `windowWidth <= 600` checks used, off by a hair.
    return useMediaQuery(theme.breakpoints.down('sm'));
}
